// Currency Popup Modal
(function() {
  'use strict';

  const popup = document.getElementById('currency-popup-modal');
  if (!popup) return;

  // Close button
  const closeBtn = popup.querySelector('.currency-popup-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      closePopup();
    });
  }

  // Click outside to close
  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      closePopup();
    }
  });

  // ESC key to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closePopup();
    }
  });

  function closePopup() {
    popup.style.display = 'none';
    sessionStorage.setItem('currencyPopupShown', 'true');
  }

  function openPopup() {
    popup.style.display = 'flex';
  }

  // Disclosure dropdowns
  function initDisclosures() {
    const disclosureToggleButtons = popup.querySelectorAll('[data-disclosure] .disclosure__toggle, .disclosure__toggle');
    
    disclosureToggleButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const disclosure = btn.closest('[data-disclosure]') || btn.closest('.disclosure');
        if (!disclosure) return;
        
        const listId = btn.getAttribute('aria-controls');
        const list = listId ? document.getElementById(listId) : disclosure.querySelector('.disclosure-list');
        
        if (!list) return;
        
        const isActive = list.classList.contains('is-active');
        
        // Close all other dropdowns
        popup.querySelectorAll('.disclosure-list.is-active').forEach(function(l) {
          if (l !== list) {
            l.classList.remove('is-active');
            const parentBtn = l.previousElementSibling;
            if (parentBtn) parentBtn.setAttribute('aria-expanded', 'false');
          }
        });
        
        if (isActive) {
          list.classList.remove('is-active');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          list.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Handle option selection
    popup.querySelectorAll('[data-disclosure-option]').forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        const value = option.getAttribute('data-value');
        if (!value) return;
        
        // Find parent form
        const form = option.closest('form');
        if (!form) return;
        
        // Update hidden input
        const hiddenInput = form.querySelector('input[type="hidden"][name="country_code"], input[type="hidden"][name="locale_code"]');
        if (hiddenInput) {
          hiddenInput.value = value;
        }
        
        // Submit form
        form.submit();
      });
    });
  }

  // Trigger button in header (if exists)
  document.querySelectorAll('.currency-popup-trigger, [data-currency-popup-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      openPopup();
    });
  });

  // Show popup on first visit (can be customized)
  function shouldShowPopup() {
    return !sessionStorage.getItem('currencyPopupShown');
  }

  // Initialize
  initDisclosures();

  // Auto-show popup if configured
  if (popup.dataset.autoShow === 'true' && shouldShowPopup()) {
    setTimeout(openPopup, 500);
  }

  // Make openPopup available globally
  window.openCurrencyPopup = openPopup;
})();